var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductMultiReport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 88 88",
    style: {
      enableBackground: "new 0 0 88 88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C29E51;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.2,71.5l-14-14l4.6-4.6l9.4,9.4l18.6-18.6l4.6,4.6L55.2,71.5z M73.3,38.9h-6.6V22.4h-6.6v9.9H27.2v-9.9h-6.6 v46.1h19.7v6.6H20.6c-1.8,0-3.4-0.6-4.6-1.9c-1.3-1.3-1.9-2.8-1.9-4.6V22.4c0-1.8,0.6-3.4,1.9-4.6c1.3-1.3,2.8-1.9,4.6-1.9h13.7 c0.6-1.9,1.8-3.5,3.5-4.7c1.8-1.2,3.7-1.9,5.8-1.9c2.2,0,4.2,0.6,5.9,1.9c1.7,1.2,2.9,2.8,3.5,4.7h13.7c1.8,0,3.4,0.6,4.6,1.9 c1.3,1.3,1.9,2.8,1.9,4.6V38.9z M43.6,22.4c0.9,0,1.7-0.3,2.3-0.9c0.6-0.6,0.9-1.4,0.9-2.3s-0.3-1.7-0.9-2.3 c-0.6-0.6-1.4-0.9-2.3-0.9s-1.7,0.3-2.3,0.9c-0.6,0.6-0.9,1.4-0.9,2.3s0.3,1.7,0.9,2.3C41.9,22.1,42.7,22.4,43.6,22.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductMultiReport);
export default __webpack_public_path__ + "static/media/product-multi-report.071167c9f4a3e4c68fded4e0d11a6799.svg";
export { ForwardRef as ReactComponent };